import { useEffect, useState } from "preact/hooks";
import cx from "classnames";
import css from "./style.scss";
import { svgIcons } from "../../helpers/svg-helpers";
import {formatAddress, formatNumber} from "../../helpers/formatters-helpers";
import {
  connectTronWallet,
  getTronBalance, getTronWallet, tronCreateTransaction
} from "../../api/tron";
import Loader from "../loader";

const ConnectTron = (props) => {
  const { to, amount, currency } = props;
  const [userAddress, setUserAddress] = useState("");
  const [userBalance, setUserBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const connect = () => {
    setLoading(true);
    connectTronWallet(currency)
      .then((walletData) => {
        if (walletData) {
          setUserAddress(walletData.address);
          setUserBalance(walletData.balance);
          setLoading(false);
        }
      })
  }

  const pay = () => {
    setLoading(true);
    tronCreateTransaction(userAddress, to, amount, currency)
      .catch(() => setLoading(false));
  }

  // useEffect(() => {
  //   setLoading(true);
  //   getTronWallet(currency)
  //     .then((walletData) => {
  //       if (walletData) {
  //         setUserAddress(walletData.address);
  //         setUserBalance(walletData.balance);
  //         setLoading(false);
  //       }
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     })
  // }, [setUserAddress, setUserBalance, setLoading]);

  useEffect(() => {
    if (userAddress) {
      window.addEventListener('message', function (e) {
        if (e.data.message && e.data.message.action == 'accountsChanged') {
          setLoading(true);
          const account = e.data?.message?.data?.address;
          getTronBalance(account, currency)
            .then((walletData) => {
              if (walletData) {
                setUserAddress(walletData.address);
                setUserBalance(walletData.balance);
                setLoading(false);
              }
            })
        }

        if (e.data.message && e.data.message.action == "setNode") {
          setLoading(true);
          getTronBalance(userAddress, currency)
            .then((walletData) => {
              if (walletData) {
                setUserAddress(walletData.address);
                setUserBalance(walletData.balance);
                setLoading(false);
              }
            })
        }

      })
    }
  }, [userAddress, setUserAddress, setUserBalance, setLoading]);

  return (
    <>
      {
        userAddress ? (
          <>
            <button
              className={cx(css.item)}
              onClick={() => pay()}
              disabled={loading || Number(userBalance) < Number(amount)}
            >
              <div className={cx(css.icon)}>{svgIcons.tron()}</div>
              { loading ? (
                <>
                  <div className={cx(css.loader)} />
                  <div className={cx(css.loader)}>
                    <Loader />
                  </div>
                </>
              ) : (
                <>
                  <div className={cx(css.name)}>{formatAddress(userAddress)}</div>
                  <div className={cx(css.balance)}>{formatNumber(userBalance)}</div>
                </>
              ) }
            </button>
            {
              Number(userBalance) < Number(amount) ? (
                <span className={cx(css.error)}>Insufficient balance  </span>
              ) : null
            }
          </>
        ) : (
          <button
            className={cx(css.item)}
            onClick={() => connect()}
            disabled={loading}
          >
            <div className={cx(css.icon)}>{svgIcons.tron()}</div>
            { loading ? (
              <>
                <div className={cx(css.loader)} />
                <div className={cx(css.loader)}>
                  <Loader />
                </div>
              </>
            ) : (
              <>
                <div className={cx(css.name)}>Connect to TronLink</div>
              </>
            ) }
          </button>
        )
      }
    </>
  );
};
export default ConnectTron;
